<template>
<div style="height: 100%;overflow-y: auto">
  <el-aside :width="isCollapse?'64px':'230px'">
    <!-- 侧边栏菜单区域 -->
    <el-menu class="my-menu" :text-color="moduletag === 2 ? '#91d9ff' : '#00CFFF'" active-text-color="#ffffff" unique-opened
      :collapse="isCollapse" :collapse-transition="true" :router="true" :default-active="activePath">
      <el-submenu :index="idx + ''" v-for="(item, idx) in menuList" :key="idx + 'idx1'">
        <!-- 一级菜单 -->
        <template slot="title">
          <!-- 图标 -->
          <img :class="moduletag === 2 ? 'img-icon' : 'img-icon1'" :src="item.icon" />
          <!-- 文本 -->
          <span class="span-font" :style="{color: item.path === activePath ? '#ffffff' : (moduletag === 2 ? '#91d9ff' : '#00CFFF')}">{{ item.name }}</span>
        </template>
        <!-- 二级菜单 -->
        <el-menu-item :index="subItem.path" v-for="(subItem, subidx) in item.lists" :key="subidx + 'idx2'">
          <template slot="title">
            <!-- 图标 -->
            <img class="img-icon" :src="subItem.path === activePath ? subItem.icon1 : subItem.icon2">
            <!-- 文本 -->
            <span class="span-font" :style="{color: subItem.path === activePath ? '#ffffff' : (moduletag === 2 ? '#91d9ff' : '#00CFFF')}">{{ subItem.name }}</span>
          </template>
        </el-menu-item>
      </el-submenu>
      <!-- 一级菜单 -->
      <el-menu-item :index="item1.path" v-for="(item1, idx1) in menuList1" :key="idx1 + 'idx3'">
        <img :class="moduletag === 2 ? 'img-icon' : 'img-icon1'" :src="item1.path === activePath ? item1.icon1 : item1.icon2">
        <span class="span-font" slot="title" :style="{color: item1.path === activePath ? '#ffffff' : (moduletag === 2 ? '#91d9ff' : '#00CFFF')}">{{ item1.name }}</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</div>
</template>

<script>
export default {
  name: 'menuBar',
  data () {
    return {
      menuList1: [],
      menuList: [],
      isCollapse: false,
      activePath: '',
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.activePath = this.$route.path
    if (this.moduletag !== 2 && (this.$store.state.user.role === 'csd' || this.$store.state.user.role === 'op')) {
      // 居家默认左侧菜单
      let aa = window.location.host
      if (aa === 'newjky.wecare-u.net' || aa === 'newhealth.wecare-u.net' ||
        aa === 'newhealth.wecare-u.net' || aa === 'bengshan.kangnh.com' || aa === 'kangnh.com') { // 上海更改
        this.menuList1 = [
          {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 3, level1: 2, path: '/customerService', name: '客服关爱', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 4, level1: 2, path: '/activeService', name: '发起服务', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
        ]
      } else {
        this.menuList1 = [
          {id: 1, level1: 2, path: '/handleAlarm', name: '事件处理', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 2, level1: 2, path: '/serviceSupplierOrder', name: '当前订单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 5, level1: 2, path: '/healthPage', name: '健康监控', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'},
          {id: 6, level1: 2, path: '/videoZg', name: '视频探访', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
        ]
      }
    } else if (this.moduletag !== 2 && this.$store.state.user.role === 'company') {
      this.menuList = [
        {
          path: '',
          name: '服务管理',
          isOpen: true,
          icon: '/static/menuIcon/a_fuwu.png',
          lists: [
            {id: 36, level1: 3, path: '/serviceOrder', name: '服务商接单', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
          ]
        },
        {
          path: '',
          name: '服务统计',
          isOpen: true,
          icon: '/static/menuIcon/a_fw.png',
          lists: [
            {id: 26, level1: 6, path: '/serviceEvent', name: '服务日志', icon1: '/static/menuIcon/xuanzhong.png', icon2: '/static/menuIcon/weixuan.png'}
          ]
        }
      ]
    }
  },
  watch: {
    $route: 'onRouteChanged'
  },
  methods: {
    onRouteChanged () {
      let that = this
      that.activePath = that.$route.path
    },
    getCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 二级菜单orgNavWrap点击
    getMenuList1 (data) {
      // console.log('new1', data)
      this.getEndData(data)
    },
    // 获取所有的菜单
    getMenuList (data) {
      // console.log('new', data)
      let arr = data.arr
      this.getEndData(arr)
    },
    getEndData (arr) {
      let arr1 = []
      let arr2 = []
      arr.forEach(val => {
        if (val.name === '') {
          arr1 = arr1.concat(val.lists)
        } else {
          arr2.push(val)
        }
      })
      this.menuList1 = arr1
      this.menuList = arr2
      // console.log(arr2)
    }
  }
}
</script>
<style>
.my-menu.el-menu{
  background: none!important;
  border: none!important;
  overflow: hidden;
}
.my-menu .el-submenu .el-menu--inline.el-menu{
  background: none!important;
  border: none!important;
}
.my-menu .el-submenu__title:hover, .el-menu-item:focus, .el-menu-item:hover{
  background-color: #1f3038 !important;
}
.el-menu--vertical .el-menu--popup-right-start{
  background: #0f1931!important;
  border-radius: 5px!important;
}
</style>
<style scoped>
.span-font{
  font-size: 15px!important;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
.img-icon{
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin: 0 10px 0 0;
}
.img-icon1{
  width: 27px;
  height: 27px;
  vertical-align: middle;
  margin: 0 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/view/components/menuBar.vue